import styled from 'styled-components';
export const ButtonClose = styled.button`
	border-radius: 08px !important;
	height: 28px !important;
	cursor: pointer !important;
	transition: all 0.2s !important;
	padding: 0 18px !important;
	border: 0 !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 08px !important;
	font-weight: 500 !important;
	transition: all 0.2s !important;
	font-size: 14px !important;
	font-weight: bold !important;
	background: white !important;
	border: 2px solid var(--ticto-red) !important;
	color: var(--ticto-red) !important;
	max-width: fit-content;

	&:hover {
		transform: scale(1.05) !important;
		filter: brightness(1.1) !important;
		text-decoration: underline !important;
	}
`;
